module.exports = __webpack_public_path__ + "img/max-file-transfer--xml.b5536880.svg";